import {formatIsoToBcp47, formatBcp47ToIso} from '@modifi/plugin-i18n'

const LOCALE_MAP: Record<string, string> = {
  zh: 'zh_CN',
  en: 'en_US',
  de: 'de_DE',
}

export const getFormattedLocale = (locale: string): string => {
  if (!locale) return ''
  const mappedLocale = Object.entries(LOCALE_MAP).find(
    ([, concreteLocale]) => concreteLocale === locale
  )?.[0]
  if (mappedLocale) {
    return mappedLocale
  }
  return formatIsoToBcp47(locale).toLowerCase()
}

export const getLocaleForSocratesLocale = (socratesLocale: string): string => {
  if (typeof LOCALE_MAP[socratesLocale] !== 'undefined') {
    return LOCALE_MAP[socratesLocale]
  }
  return formatBcp47ToIso(socratesLocale)
}
